import React, {useEffect, useState} from 'react';
import PitcherTable from './PitcherTable';
import ballImage from '../../assets/img/icon/ball_icon.png';
import {useCookies} from 'react-cookie';
import dateSetting from '../../utils/dateSetting';
import axios from 'axios';
import _ from 'lodash';
import { flatObject } from '../../utils/flat';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';

function FuturesPitcherTableWrapper({title, id, column, profile, season}) {
    const [cookies] = useCookies(['hiball_token']);
    let [batterType, setBatterType] = useState('total');
    let [tableData, setTableData] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let {playerId} = profile;

        let params ={
            pitcherIds: playerId,
            seasons: season,
            gameTypeCode: 4206,
            authToken:JSON.stringify(cookies['hiball_token']),
            recordType: 'futuresRecordService'
        };

        params['recordName'] = 'futuresPitcherCountTypeRecord';

        if(batterType !== 'total') {
            params['battingHands'] = batterType;
        }

        axios({
            url : `${process.env.REACT_APP_API_URL}`,params
        }).then(result => {
            let innerData = result['data']['result'];

            let newArr = _.map(innerData, (item) => {
                return flatObject(item);
            });

            setTableData(newArr);
        })
    }, [batterType]);

    function batterTypeHander(event) {
        let value = event.target.value;
        setBatterType(value);
    }

    return (
        <>
        <div className="tableBox">
            <div className="tableTitle">
                <img src={ballImage} alt='#'/> {title}
                <span id={id+"_stat"}></span>
            </div>
            <div style={{position:'relative'}} className="table_select_div">
                <div style={{position:'absolute', top:'-40px', right: '10px'}}>
                    <div className="formTitle">{t('batterHits')}</div>
                    <Form.Group onChange={batterTypeHander} style={{display:'inline-block'}}>
                        <Form.Select size="sm">
                            <option value="total">{t('all')}</option>
                            <option value="R">{t('hitRight')}</option>
                            <option value="L">{t('hitLeft')}</option>
                        </Form.Select>
                    </Form.Group>
                </div>
            </div>
            <div className="tableDiv">
                <PitcherTable data={tableData} column={column}/>
            </div>
        </div>
        </>
    )
}

export default FuturesPitcherTableWrapper;